export default class EventManagerService {
    private static eventIdIncrement = 0;
    public static listeners: { [key: string]: {} } = {
    };
    // @ts-ignore
    public on(eventName: string, callback) {
        EventManagerService.eventIdIncrement++;
        // @ts-ignore
        if (EventManagerService.listeners[eventName] === undefined) {
            // @ts-ignore
            EventManagerService.listeners[eventName] = {};
        }
        // @ts-ignore
        EventManagerService.listeners[eventName][EventManagerService.eventIdIncrement] = callback;
        return EventManagerService.eventIdIncrement;
    }
    public removeListener(eventId: number) {
        for (const [eventName, listeners] of Object.entries(EventManagerService.listeners)) {
            for (const eid of Object.keys(listeners)) {
                if (parseInt(eid) === eventId) {
                    // @ts-ignore
                    delete listeners[eid];
                }
            }
        }
    }
    // @ts-ignore
    public emit(eventName: string, payload) {
        // @ts-ignore
        if (!EventManagerService.listeners[eventName]) return;
        // @ts-ignore
        for (const eid of Object.keys(EventManagerService.listeners[eventName])) {
            // @ts-ignore
            EventManagerService.listeners[eventName][eid](payload);
        }
    }
}